module.exports = __webpack_public_path__ + "img/solution1_chart1.131cba34.png";